<mat-checkbox [(ngModel)]="checked"
              (ngModelChange)="onchange($event)"
              [disabled]="disabled"
              [checked]="checked"
              [indeterminate]="indeterminate"
              [disableRipple]="disableRipple">
  <ng-content></ng-content>
</mat-checkbox>
